<template>
    <div>
        <div class="accordion_detail" v-if="typeStructure == 'desktop'">
            <v-expansion-panels>
                <v-expansion-panel class="espansion_panel_cursos_details">
                    <v-expansion-panel-header style="width:175px">
                        <span class="see_detailt">VER DETALLE</span>
                        <template v-slot:actions>
                            <v-icon color="#00A8E1">$expand</v-icon>
                        </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <div class="content_expanded_section">
                            <div class="row_accordion">
                                <div class="row_accordion_left">Sede</div>
                                <div class="row_accordion_left">Modalidad</div>
                                <div class="row_accordion_left">Frecuencia</div>
                                <div class="row_accordion_left">Horario</div>
                                <div class="row_accordion_left">
                                    Fecha de Inicio / Fin
                                </div>
                                <div class="row_accordion_left">Docente</div>
                                <div class="row_accordion_left">Grupo</div>
                            </div>
                            <div class="row_accordion_var">
                                <div class="row_accordion_right">
                                    {{
                                        items.campus
                                            ? items.campus
                                            : "-"
                                    }}
                                </div>
                                <div class="row_accordion_right">
                                    {{
                                        items.modality
                                            ? items.modality
                                            : "-"
                                    }}
                                </div>
                                <div class="row_accordion_right">
                                    {{
                                        items.frequency
                                            ? items.frequency
                                            : "-"
                                    }}
                                </div>
                                <div class="row_accordion_right">
                                    {{
                                        items.schedule
                                            ? items.schedule
                                            : "-"
                                    }}
                                </div>
                                <div class="row_accordion_right">
                                    {{
                                        items.start_date
                                            ? items.start_date
                                            : "-"
                                    }}
                                    /
                                    {{
                                        items.end_date
                                            ? items.end_date
                                            : "-"
                                    }}
                                </div>
                                <div class="row_accordion_right">
                                    {{
                                        items.teacher
                                            ? items.teacher
                                            : "-"
                                    }}
                                </div>
                                <div class="row_accordion_right">
                                    {{
                                        items.classroom
                                            ? items.classroom
                                            : "-"
                                    }}
                                </div>
                                <!-- <div class="row_accordion_right">
                                    <a class="extra" href>Ver Lista Companeros</a>
                                    </div>
                                    <div class="row_accordion_right">
                                        <v-progress-linear
                                        style="margin-top:10px"
                                        background-color="#7e8596"
                                        color="#00ABE7"
                                        value="25"
                                    ></v-progress-linear>
                                </div>-->
                            </div>
                        </div>

                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </div>
        <div class="hide_expansion" style="padding:0" v-if="typeStructure == 'mobile'">
            <v-expansion-panels>
                <v-expansion-panel class="espansion_panel_cursos_details">
                    <v-expansion-panel-header style="width:175px;padding:0">
                        <span class="see_detailt">VER DETALLE</span>
                        <template v-slot:actions>
                            <v-icon color="#00A8E1">$expand</v-icon>
                        </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <div class="content_expanded_section2">
                            <div class="row_accordion">
                                <div class="row_accordion_left">Sede</div>
                                <div class="row_accordion_right">
                                    {{
                                        items.campus
                                            ? items.campus
                                            : "-"
                                    }}
                                </div>
                                <div class="row_accordion_left">Modalidad</div>
                                <div class="row_accordion_right">
                                    {{
                                        items.modality
                                            ? items.modality
                                            : "-"
                                    }}
                                </div>
                                <div class="row_accordion_left">Frecuencia</div>
                                <div class="row_accordion_right">
                                    {{
                                        items.frequency
                                            ? items.frequency
                                            : "-"
                                    }}
                                </div>
                                <div class="row_accordion_left">Horario</div>
                                <div class="row_accordion_right">
                                    {{
                                        items.schedule
                                            ? items.schedule
                                            : "-"
                                    }}
                                </div>
                                <div class="row_accordion_left">
                                    Fecha de Inicio / Fin
                                </div>
                                <div class="row_accordion_right">
                                    {{
                                        items.start_date
                                            ? items.start_date
                                            : "-"
                                    }}
                                    /
                                    {{
                                        items.end_date
                                            ? items.end_date
                                            : "-"
                                    }}
                                </div>
                                <div class="row_accordion_left">Docente</div>
                                <div class="row_accordion_right">
                                    {{
                                        items.teacher
                                            ? items.teacher
                                            : "-"
                                    }}
                                </div>
                                <div class="row_accordion_left">Grupo</div>
                                <div class="row_accordion_right">
                                    {{
                                        items.classroom
                                            ? items.classroom
                                            : "-"
                                    }}
                                </div>
                            </div>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AccordionCourseDetail',
    data() {
        return {
           
        }
    },
    props: ['items','typeStructure']
}
</script>